import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-anonymou-header',
  templateUrl: './anonymou-header.component.html',
  styleUrl: './anonymou-header.component.css'
})
export class AnonymouHeaderComponent implements OnInit, OnDestroy {
  label!: string;
  routeSub: Subscription = new Subscription;
  icon:string = '';
  constructor(private route: ActivatedRoute, private router: Router) {}
  updateLabel() {
    const currentRoute = this.router.url; // Get the current URL

    switch (currentRoute) {
      case '/register/createAccount':
        this.label = '';
        break;
      case '/register/registerAsOwner':
        this.label = 'Individual property owner';
        this.icon = 'person';
        break;
      case '/register/registerAsPropertyManagmentCompany':
        this.label = 'Property management company';
        this.icon = 'domain_add'
        break;
        case '/register/registerAsHotelMotel':
          this.label = 'Bed & Breakfast / Hotel / Motel';
          this.icon = "bed";
          break;
          case '/register/printLegalAgreement':
          this.label = 'Legal Agreement';
          this.icon = "";
          break;
      default:
        this.label = '';
        break;
    }
  }
  ngOnInit(): void {
    this.routeSub = this.router.events.subscribe(() => {
      this.updateLabel();
    });
  
    this.updateLabel();
  }
  ngOnDestroy(): void { 
  }
}
